const Success = () => (
    <svg
        width='62'
        height='46'
        viewBox='0 0 62 46'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M4.5 23.9213L22.1667 40.9787L57.5 4.427'
            stroke='white'
            strokeWidth='8.22414'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export default Success;
